import type {
    CartEventProduct,
    CartLineItem,
    CartProduct,
    CartVoucherProduct,
} from '../interfaces/Cart.model';

export const isEventProduct = (product: CartProduct): product is CartEventProduct => {
    return product.type === 'event';
};

export const isVoucherProduct = (product: CartProduct): product is CartVoucherProduct => {
    return product.type === 'voucher';
};

export const isWorkshopLineItem = (item: CartLineItem): boolean => {
    return isEventProduct(item.product);
};
